import split from 'lodash/split';
import { IComment } from '../../../../components/Comments/Comment';
import {
  CorrespondenceDetails,
  ListCorrespondenceTypeResponse,
} from '../../../../state/slice/models/CorrespondenceTypes';
import { sanitize } from 'isomorphic-dompurify';
export default class CorrespondenceDataAdapter {
  private correspondenceResponseList: ListCorrespondenceTypeResponse;

  constructor(correspondeceResponseList: ListCorrespondenceTypeResponse) {
    this.correspondenceResponseList = correspondeceResponseList;
  }

  getUserComments(): Array<IComment> {
    return this.correspondenceResponseList?.correspondenceDetailsList
      ?.map((correspondence: CorrespondenceDetails) => {
        return {
          id: correspondence.correspondenceId,
          postedBy: split(correspondence.createdByUserEmail, '@', 1).toString(),
          time: new Date(correspondence.createdOn).toString(),
          content: sanitize(correspondence.correspondence),
          documentList: correspondence.documentList,
          correspondenceType: correspondence.correspondenceType,
          createdByUserId: correspondence.createdByUserId,
        };
      })
      .reverse();
  }
}
